import classNames from 'classnames'

import type { ReactElement } from 'react'
import type { IBlockProps } from '~/types/template'

import './styles.scss'

const BackgroundImageBlock = ({ asset, children, className }: IBlockProps): ReactElement => {
  const { download_url, mime_type } = asset || {}

  const classes = classNames('background-image-block center-cropped', className, { 'no-image': !download_url })

  const componentStyle = download_url ? { backgroundImage: `url(${download_url})` } : undefined

  const fileType = mime_type?.split('/')[0] === 'video' ? 'video' : 'image'

  return (
    <div className={classes} style={componentStyle}>
      {fileType === 'video' ? <video autoPlay className="video-content" loop muted src={download_url} /> : null}
      {children}
    </div>
  )
}

export default BackgroundImageBlock
